export const UPDATE_SPOT_REQUEST = 'UPDATE_SPOT_REQUEST';

export const updateSpotRequest = ( id: string, updateData: {} ) => ({
    type: UPDATE_SPOT_REQUEST,
    payload: { id, updateData }
});
